function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#002A33;}\n\t.st2{clip-path:url(#SVGID_00000074443517374215772760000010515881962163849916_);}\n\t.st3{fill:#6CB9B2;}\n\t.st4{fill:#82C695;}\n\t.st5{fill:#6ABF8E;}\n\t.st6{fill:#62B189;}\n\t.st7{fill:#A5D3A5;}\n\t.st8{fill:#C2DEB2;}\n\t.st9{fill:#89C99B;}\n\t.st10{fill:#4DA17E;}\n\t.st11{fill:#127E5C;}\n\t.st12{fill:#CFE3B1;}\n\t.st13{fill:#A8D7F1;}\n\t.st14{fill:#8DCEEF;}\n\t.st15{fill:#C6E5F6;}\n\t.st16{fill:#70C3EB;}\n\t.st17{fill:#DFF0FA;}\n\t.st18{fill:#4ABAE8;}\n\t.st19{fill:#784E95;}\n\t.st20{fill:#653E8B;}\n\t.st21{fill:#8962A1;}\n\t.st22{fill:#3E265D;}\n\t.st23{fill:#A480B5;}\n\t.st24{fill:#5F3586;}\n\t.st25{fill:#2E1E47;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 139.9,
  cy: 139.9,
  r: 131.4
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M139.9,279.7C62.7,279.7,0,217,0,139.9S62.7,0,139.9,0s139.9,62.7,139.9,139.9S217,279.7,139.9,279.7z  M139.9,17C72.1,17,17,72.1,17,139.9s55.1,122.9,122.9,122.9s122.9-55.1,122.9-122.9S207.6,17,139.9,17z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "SVGID_1_",
  cx: 140,
  cy: 139.8,
  rx: 123.1,
  ry: 122.6
}));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: -22.6,
  y: -9.5,
  className: "st3",
  width: 319.4,
  height: 319.4
});

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st4",
  points: "115.4,50 22.9,50 22.9,167.8 254.2,167.8 254.2,132.2 254.2,50  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M115.4,50v10.8h115.4v0c0,6.6,6.7,9.7,11.9,8.6h0.1v62.8h11.5V50H115.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M242.7,146.1L242.7,146.1c-3.2,0-6.2,1.3-8.4,3.5s-3.5,5.4-3.5,8.6c0,0.5,0.1,1.1,0.1,1.6H47.4V157h-0.1 c0-0.4,0.1-0.7,0.1-1.1c0-6.4-5.3-11.8-11.8-11.8c-0.2,0-0.4,0-0.6,0v-72c0.2,0,0.4,0,0.6,0c6.3,0,11.5-5.1,11.7-11.4h68V50 H22.9v117.8h231.4v-35.6h-11.5L242.7,146.1L242.7,146.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M239.5,72.6L239.5,72.6l0.1,65.2v5.9h-0.1c-3.1,0-6.1,1.2-8.3,3.4c-2.2,2.2-3.4,5.2-3.4,8.3 c0,0.5,0.1,1,0.1,1.5H47.4v2.8h183.5c-0.1-0.5-0.1-1-0.1-1.6c0-3.2,1.3-6.3,3.5-8.6s5.2-3.5,8.4-3.5h0.1V69.4h-0.1 c-5.1,1.1-11.9-2-11.9-8.6v0h-3v0C227.8,67.2,233.1,72.6,239.5,72.6L239.5,72.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M71.9,94.6c7.2,0.8,12.8,6.9,12.8,14.3s-5.6,13.5-12.8,14.3v14.6h35.2c-7.3-7.7-11.8-18.2-11.8-29.7 c0-23.9,19.4-43.2,43.2-43.2s43.2,19.4,43.2,43.2c0,11.5-4.5,21.9-11.8,29.7h37.9v-14.6c-0.4,0-0.7,0.1-1.1,0.1 c-7.9,0-14.4-6.4-14.4-14.4s6.4-14.4,14.4-14.4c0.4,0,0.8,0,1.1,0.1V60.8h-136V94.6L71.9,94.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M221.1,108.9c0,7.6-5.9,13.8-13.3,14.3v14.6h21.5c-0.1-0.3-0.2-0.6-0.2-0.9V79.2c0-1.5,1.2-2.7,2.6-2.7 s2.6,1.2,2.6,2.7v57.7c0,0.3-0.1,0.6-0.2,0.9h5.4V72.6h-0.1c-6.4,0-11.8-5.3-11.8-11.8v0h-19.9v33.8 C215.3,95.1,221.1,101.3,221.1,108.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M227.9,157c-0.1-0.5-0.1-1-0.1-1.5c0-3.1,1.2-6.1,3.4-8.3c2.2-2.2,5.2-3.4,8.3-3.4h0.1v-5.9h-5.4 c-0.4,1.1-1.3,1.8-2.4,1.8s-2.1-0.8-2.4-1.8H170c-7.9,8.3-19,13.6-31.4,13.6s-23.5-5.2-31.4-13.6H71.9v-14.6 c-0.5,0.1-1,0.1-1.6,0.1c-8,0-14.4-6.4-14.4-14.4s6.5-14.4,14.4-14.4c0.5,0,1,0,1.6,0.1V60.8H47.4c-0.2,6.2-5.5,11.4-11.7,11.4 c-0.2,0-0.4,0-0.6,0v72.1c0.2,0,0.4,0,0.6,0c6.4,0,11.8,5.4,11.8,11.8c0,0.4,0,0.7-0.1,1.1H227.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M145.1,127.2c3.3-1.8,5.8-4.9,5.3-8.9c-0.2-1.8-1-3.2-2.2-4.2c-1-0.4-2.1-0.7-3.2-0.9 C145,117.8,145.1,122.5,145.1,127.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M131.7,92.4c-0.2,0.2-0.4,0.4-0.6,0.7c-0.1,0.2-0.4,0.5-0.4,0.6c-0.2,0.3-0.4,0.7-0.6,1l0,0 c0,0.1,0,0.1-0.1,0.2c-0.1,0.2-0.1,0.4-0.2,0.6c0,0.2,0,0.5,0,0.6c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.2,0.1,0.3 c0.1,0.2,0.3,0.6,0.3,0.7c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.5,0.6,0.6,0.6c0.8,0.7,0.6,0.7,1.8,1.3c0.5,0.3,0.9,0.5,1.4,0.7 c-0.1-3.2-0.1-6.3-0.2-9.5c-0.1,0.1-0.2,0.1-0.4,0.2C132.2,91.9,132.8,91.3,131.7,92.4L131.7,92.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M138.6,151.4c12.4,0,23.5-5.2,31.4-13.6c7.3-7.7,11.8-18.2,11.8-29.7c0-23.9-19.4-43.2-43.2-43.2 s-43.2,19.4-43.2,43.2c0,11.5,4.5,21.9,11.8,29.7C115,146.2,126.1,151.4,138.6,151.4L138.6,151.4z M134.4,127.6 c-0.1-5.5-0.1-11-0.1-16.6c-3-0.8-5.9-1.9-8.5-3.8c-1.1-0.5-2.1-1.2-3.1-1.9c-7.4-5.6-6.6-15.2,0.3-20.9 c3.2-2.6,6.8-4.1,10.7-4.6c0-2-0.1-4-0.1-6.1c0-2.6,2.7-3.5,4.5-2.7c2.4-1.3,6.1-0.2,6.2,3.4c0,1.7,0,3.3,0,5 c3.4,0.6,6.7,1.8,9.8,3.8c5.5,3.5,0.4,12.2-5.1,8.7c-1.6-1-2.9-1.7-4.5-2.2c0.1,4.4,0.2,8.8,0.3,13.2c3,0.6,5.9,1.2,8.7,2.5 c13.4,6.2,11.1,24.9-1.4,30.8c-2.2,1-4.4,1.7-6.8,2.1c0,1.2,0.1,2.3,0.1,3.5c0.2,4.3-5.3,5-7.3,2.2c-1.6,0.1-3.2-0.9-3.3-3 c-0.1-1-0.1-2-0.1-3.1c-1.4-0.3-2.7-0.7-4-1.2c-1.4-0.6-2.8-1.3-4.1-2.2c-5.4-2.2-9.4-6.5-9.3-13.1c0-3,2.8-4.2,5-3.6 c3-1.5,7.5-0.1,7.4,4.3c0,0,0.2,1.4,0.1,1.2C130.5,125.4,132.2,126.7,134.4,127.6L134.4,127.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M56,108.9c0,7.9,6.5,14.4,14.4,14.4c0.5,0,1,0,1.6-0.1c7.2-0.8,12.8-6.9,12.8-14.3s-5.6-13.5-12.8-14.3 c-0.5-0.1-1-0.1-1.6-0.1C62.4,94.5,56,101,56,108.9L56,108.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st10",
  d: "M221.1,108.9c0-7.6-5.9-13.8-13.3-14.3c-0.4,0-0.7-0.1-1.1-0.1c-7.9,0-14.4,6.4-14.4,14.4 s6.4,14.4,14.4,14.4c0.4,0,0.8,0,1.1-0.1C215.3,122.7,221.1,116.5,221.1,108.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M125.8,107.2c2.6,1.9,5.5,3,8.5,3.8c0-0.4,0-0.8,0-1.2C131.4,109.2,128.5,108.5,125.8,107.2L125.8,107.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M129.8,122.4c0.1-4.4-4.4-5.8-7.4-4.3c1.5,0.4,2.7,1.6,2.7,3.6c-0.1,4.6,5,6.7,9.5,7.3c0-0.4,0-0.9,0-1.4 c-2.2-0.8-4-2.1-4.6-4.1C130,123.7,129.8,122.4,129.8,122.4L129.8,122.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M145.1,127.2c-0.1-4.7-0.1-9.3-0.1-14c1.1,0.2,2.2,0.5,3.2,0.9c-2-1.8-5-2.6-7.8-3.1 c0.1,6,0.1,11.9,0.2,17.9C142.1,128.5,143.7,128,145.1,127.2L145.1,127.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M139.8,73.7c0,2,0,4.1,0.1,6.1c3.6,0.5,7,1.8,10.1,3.7c4.2,2.7,0.3,9.3-3.9,6.6c-1.9-1.2-4-2.1-6.1-2.6 c0.1,5.2,0.2,10.4,0.3,15.6c2.4,0.4,4.8,0.9,7.1,1.8c5.8,2.3,10.5,6.7,10.6,13.3c0.2,6.6-3.8,13-9.7,15.9 c-2.2,1.1-4.8,1.8-7.6,2.2c0.1,1.6,0.1,3.2,0.2,4.7c0.1,1.9-1.3,2.9-2.8,3c2.1,2.8,7.6,2.1,7.3-2.2c-0.1-1.2-0.1-2.3-0.1-3.5 c2.3-0.4,4.6-1.1,6.8-2.1c12.5-5.9,14.8-24.6,1.4-30.8c-2.8-1.3-5.8-2-8.7-2.5c-0.1-4.4-0.2-8.8-0.3-13.2c1.6,0.5,3,1.2,4.5,2.2 c5.5,3.5,10.6-5.2,5.1-8.7c-3.1-2-6.4-3.2-9.8-3.8c0-1.7,0-3.3,0-5c0-3.6-3.8-4.7-6.2-3.4C139.1,71.5,139.8,72.4,139.8,73.7 L139.8,73.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M132.7,99.6c-1.2-0.7-1.1-0.6-1.8-1.3c-0.1-0.1-0.4-0.5-0.6-0.6c-0.1-0.1-0.1-0.2-0.2-0.3 c0-0.1-0.2-0.5-0.3-0.7c0-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1,0-0.2c0-0.1,0-0.4,0-0.6c0.1-0.2,0.1-0.4,0.2-0.6c0-0.1,0-0.2,0.1-0.2 l0,0c0.2-0.4,0.4-0.7,0.6-1.1c0.1-0.1,0.3-0.4,0.4-0.6c0.2-0.2,0.4-0.5,0.6-0.7c1.1-1.1,0.5-0.6,1.8-1.4 c0.1-0.1,0.2-0.2,0.4-0.2c0-1.1,0-2.2-0.1-3.3c-0.4,0.1-0.8,0.2-1.2,0.3c-3,0.9-6.5,3.2-7.3,6.1c-0.3,1.2-0.4,2.3,0.3,3.4 c1,1.6,2.7,2.6,4.4,3.3c1.4,0.6,2.8,1,4.2,1.4c0-0.6,0-1.1,0-1.7C133.6,100.1,133.2,99.9,132.7,99.6L132.7,99.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M126.6,134.7c1.3,0.9,2.6,1.6,4.1,2.2c1.3,0.5,2.6,0.9,4,1.2c0-0.5,0-1-0.1-1.6 C131.8,136.3,129.1,135.7,126.6,134.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M125,121.6c0-2-1.2-3.2-2.7-3.6c-2.2-0.6-5,0.6-5,3.6c-0.1,6.6,3.9,10.8,9.3,13.1c2.5,1,5.2,1.6,8,1.9 c0,0.5,0,1,0.1,1.6c0,1,0.1,2,0.1,3.1c0.1,2,1.8,3,3.3,3c1.5-0.1,2.9-1,2.8-3c-0.1-1.6-0.1-3.2-0.2-4.7c2.8-0.3,5.4-1.1,7.6-2.2 c5.9-3,9.8-9.4,9.7-15.9c-0.2-6.7-4.9-11.1-10.6-13.3c-2.3-0.9-4.7-1.4-7.1-1.8c-0.1-5.2-0.2-10.4-0.3-15.6 c2.1,0.5,4.2,1.4,6.1,2.6c4.2,2.7,8-4,3.9-6.6c-3.1-2-6.6-3.3-10.1-3.7c0-2-0.1-4.1-0.1-6.1c0-1.3-0.7-2.2-1.6-2.7 c-1.8-0.9-4.5,0-4.5,2.7c0,2,0,4,0.1,6.1c-3.8,0.5-7.5,2-10.7,4.6c-6.9,5.7-7.6,15.3-0.3,20.9c1,0.8,2,1.4,3.1,1.9 c2.6,1.3,5.5,2.1,8.4,2.7c0,0.4,0,0.8,0,1.2c0.1,5.5,0.1,11.1,0.1,16.6c0,0.4,0,0.9,0,1.4C130,128.3,125,126.2,125,121.6 L125,121.6z M148.2,114.1c1.1,1,2,2.4,2.2,4.2c0.5,4-2,7-5.3,8.9c-1.4,0.8-3,1.4-4.5,1.7c-0.1-6-0.1-11.9-0.2-17.9 C143.2,111.5,146.2,112.3,148.2,114.1L148.2,114.1z M129.9,100.6c-1.7-0.8-3.3-1.8-4.3-3.3c-0.7-1.2-0.7-2.2-0.3-3.4 c0.8-2.9,4.3-5.2,7.4-6.1c0.4-0.1,0.8-0.2,1.2-0.3c0,1.1,0,2.2,0.1,3.3c0.1,3.2,0.1,6.3,0.2,9.5c0,0.6,0,1.1,0,1.7 C132.7,101.7,131.3,101.2,129.9,100.6L129.9,100.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M231.7,139.6c1.1,0,2.1-0.8,2.4-1.8c0.1-0.3,0.2-0.6,0.2-0.9V79.2c0-1.5-1.2-2.7-2.6-2.7s-2.6,1.2-2.6,2.7 v57.7c0,0.3,0.1,0.6,0.2,0.9C229.7,138.9,230.6,139.6,231.7,139.6z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "119,170 157.6,170 157.6,170 138.3,136.7 119,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "181.1,136.7 138.3,136.7 157.6,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st15",
  points: "138.3,136.7 95.5,136.7 119,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "157.6,170 207.6,170 181.1,136.7 157.6,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "119,170 95.5,136.7 69,170 119,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "119,170 138.3,268.4 157.6,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st18",
  points: "157.6,170 138.3,268.4 207.6,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st15",
  points: "69,170 138.3,268.4 119,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st19",
  points: "119,170 157.6,170 157.6,170 138.3,136.7 119,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st20",
  points: "181.1,136.7 138.3,136.7 157.6,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st21",
  points: "138.3,136.7 95.5,136.7 119,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st22",
  points: "157.6,170 207.6,170 181.1,136.7 157.6,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st23",
  points: "119,170 95.5,136.7 69,170 119,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st24",
  points: "119,170 138.3,268.4 157.6,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st25",
  points: "157.6,170 138.3,268.4 207.6,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st19",
  points: "69,170 138.3,268.4 119,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st13",
  points: "119,170 157.6,170 157.6,170 138.3,136.7 119,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "181.1,136.7 138.3,136.7 157.6,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st15",
  points: "138.3,136.7 95.5,136.7 119,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st16",
  points: "157.6,170 207.6,170 181.1,136.7 157.6,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st17",
  points: "119,170 95.5,136.7 69,170 119,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st14",
  points: "119,170 138.3,268.4 157.6,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st18",
  points: "157.6,170 138.3,268.4 207.6,170  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st15",
  points: "69,170 138.3,268.4 119,170  "
}));

function SvgQ4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 279.7 279.7",
    style: {
      enableBackground: "new 0 0 279.7 279.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027588136902293864390000004349779952771176865_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000027588136902293864390000004349779952771176865_)"
    }
  }, _ref5, _ref6, _ref7))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ4);
export default __webpack_public_path__ + "static/media/q4.6fc8e159fc843acb3a84ada4ef309a6d.svg";
export { ForwardRef as ReactComponent };